import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useProjectMediaGalleriesState = create((set) => ({
  projectMediaGalleries: {
    data: [],
    meta: {},
    tag_id_filters: [],
  },
  setProjectMediaGalleries: (payload) =>
    set((state) => ({
      projectMediaGalleries: {
        ...state.projectMediaGalleries,
        ...payload,
      },
    })),
}));

export const useDigitalProfile = create((set) => ({
  digitalProfile: {},
  setDigitalProfile: (payload) =>
    set((state) => ({
      digitalProfile: payload,
    })),
}));

export const useConnectFormState = create(
  persist(
    (set) => ({
      // Stored connect form data
      whatsappNumber: "",
      fullName: "",
      siteLocation: "",
      // Actions
      setWhatsappNumber: (value) => set({ whatsappNumber: value }),
      setFullName: (value) => set({ fullName: value }),
      setSiteLocation: (value) => set({ siteLocation: value }),
      setFormData: (data) =>
        set({
          whatsappNumber: data.whatsappNumber ?? "",
          fullName: data.fullName ?? "",
          siteLocation: data.siteLocation ?? "",
        }),
      clearFormData: () =>
        set({
          whatsappNumber: "",
          fullName: "",
          siteLocation: "",
        }),
    }),
    {
      name: "multiply-user-connect-form", // localStorage key for user's persisted connect form data
      partialize: (state) => ({
        whatsappNumber: state.whatsappNumber,
        fullName: state.fullName,
        siteLocation: state.siteLocation,
      }),
    }
  )
);

// Shared by (main_app)/lead-gen-profiles and fevicol-inhomz/find-contractors
// — each has its own FILTER_CONFIG with different category keys, so `selected`
// is a plain, category-agnostic record; every consumer reads
// `selected[category] || []` and falls back to [] for keys it doesn't define.
export const useContractorFiltersStore = create(
  persist(
    (set) => ({
      // Stored contractor filters
      appliedFilters: {
        selected: {},
      },
      // Actions
      setAppliedFilters: (filters) => set({ appliedFilters: filters }),
      clearFilters: () =>
        set({
          appliedFilters: {
            selected: {},
          },
        }),
    }),
    {
      name: "multiply-contractor-filters", // localStorage key for persisted filters
      partialize: (state) => ({
        appliedFilters: state.appliedFilters,
      }),
    }
  )
);

